/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const CartIcon = /*#__PURE__*/ createSvgIcon(
  'CartIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M5.496 18c-.414 0-.767-.147-1.059-.442A1.456 1.456 0 014 16.496c0-.414.147-.767.442-1.058A1.456 1.456 0 015.504 15c.414 0 .767.147 1.059.442.291.294.437.649.437 1.062 0 .414-.147.767-.442 1.058A1.456 1.456 0 015.496 18zm9 0c-.414 0-.767-.147-1.059-.442A1.456 1.456 0 0113 16.496c0-.414.147-.767.442-1.058A1.456 1.456 0 0114.504 15c.414 0 .767.147 1.059.442.291.294.437.649.437 1.062 0 .414-.147.767-.442 1.058a1.456 1.456 0 01-1.062.438zM5.27 5.5L7 9.5h6.27l1.71-4H5.27zM4.625 4H16.5c.194 0 .337.076.427.23.09.152.1.312.031.478l-2.32 5.372c-.12.28-.301.503-.544.67-.243.167-.518.25-.823.25H6.604l-.875 1.5h9.521c.213 0 .39.072.534.214a.72.72 0 01.216.532c0 .21-.072.39-.216.535a.72.72 0 01-.534.219h-9.5c-.597 0-1.038-.251-1.323-.753-.285-.502-.281-1.001.01-1.497l1.084-1.875L2.79 3.5H1.75a.728.728 0 01-.534-.214A.72.72 0 011 2.754c0-.21.072-.39.216-.535A.72.72 0 011.75 2h1.52c.154 0 .289.042.407.125a.882.882 0 01.281.333L4.625 4z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  true
);

export default CartIcon;
